"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferFieldIsPaid = OfferFieldIsPaid;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const react_intl_1 = require("react-intl");
const offer_1 = require("@src/types/offer");
function OfferFieldIsPaid() {
    const intl = (0, react_intl_1.useIntl)();
    return ((0, jsx_runtime_1.jsx)(antd_1.Form.Item, { noStyle: true, shouldUpdate: (prevValues, curValues) => prevValues[offer_1.EOfferBasicInfoFormField.offerTypeId] !== curValues[offer_1.EOfferBasicInfoFormField.offerTypeId], children: ({ getFieldValue }) => ((0, jsx_runtime_1.jsx)(antd_1.Form.Item, { label: intl.formatMessage({
                id: 'admin.offer_form.is_position_paid',
            }), name: offer_1.EOfferBasicInfoFormField.isPaid, rules: [
                {
                    required: true,
                    message: intl.formatMessage({
                        id: 'admin.offer_validation.please_select_if_salaried',
                    }),
                },
            ], children: (0, jsx_runtime_1.jsx)(antd_1.Radio.Group, { disabled: getFieldValue(offer_1.EOfferBasicInfoFormField.offerTypeId) !== offer_1.EOfferType.internship, children: (0, jsx_runtime_1.jsxs)(antd_1.Space, { direction: "vertical", children: [(0, jsx_runtime_1.jsx)(antd_1.Radio, { value: true, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.offer_form.yes" }) }), (0, jsx_runtime_1.jsx)(antd_1.Radio, { value: false, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.offer_form.no" }) })] }) }) })) }));
}
